import React from 'react';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';
import { ConfigFieldControl, ConfigTextField, PageTemplate, PageTemplateDashboard, PageTemplateHeader, PageTemplateHeaderActions } from '@sierralabs/core-ui';
import { useConfigComponent } from '../../hooks/component/useConfigComponent';
import { useSubscribeComponentChanges } from '../../hooks/component/useSubscribeComponentChanges';
import SlotRenderer from '../renderers/SlotRenderer';
import { SiteComponent } from '../SiteComponentPlugin';
const StyledPageTemplate = styled(PageTemplate) `
  .page-template-dashboard.board-view {
    padding: 0;
  }
`;
export const SiteTraceBoardPage = props => {
    var _a;
    const component = useSubscribeComponentChanges(SiteTraceBoardPagePlugin, props);
    return (React.createElement(SiteComponent, Object.assign({ plugin: SiteTraceBoardPagePlugin }, props),
        React.createElement(StyledPageTemplate, null,
            React.createElement(PageTemplateHeader, null,
                React.createElement(Typography, { variant: 'h2' }, (_a = component.props) === null || _a === void 0 ? void 0 : _a.heading),
                React.createElement(PageTemplateHeaderActions, { flex: true },
                    React.createElement(SlotRenderer, { component: component, slot: 'header-actions' }))),
            React.createElement(PageTemplateDashboard, { className: 'board-view' },
                React.createElement(SlotRenderer, { component: component, slot: 'trace-board' })))));
};
export const SiteTraceBoardPageConfigurator = props => {
    var _a;
    const { component } = props;
    const { update } = useConfigComponent(component);
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfigFieldControl, null,
            React.createElement(ConfigTextField, { fullWidth: true, label: 'Heading', value: ((_a = component.props) === null || _a === void 0 ? void 0 : _a.heading) || '', onChange: event => update('props.heading', event.target.value) }))));
};
export const SiteTraceBoardPagePlugin = {
    name: 'Site Trace Board Page',
    type: 'site-trace-board-page',
    component: SiteTraceBoardPage,
    configurator: SiteTraceBoardPageConfigurator,
    slots: [
        {
            name: 'Header Actions',
            type: 'component-stack',
            slot: 'header-actions'
        },
        {
            name: 'Trace Board',
            type: 'site-trace-board',
            slot: 'trace-board'
        }
    ]
};
//# sourceMappingURL=SiteTraceBoardPagePlugin.js.map